/* =====================================================================
   İş günü / tatil hesabı + takvim-temelli tarih aritmetiği.
   "kesinlesme.html" içindeki is-gunu-hesap mantığından birebir taşındı.

   ÖNEMLİ: Tüm tarihler yerel `new Date(y, mo-1, d)` ile kurulur ve `toIso`
   yerel getter'larla serileştirilir → timezone-güvenli. ISO string'i ASLA
   doğrudan `new Date('YYYY-MM-DD')`'e verme (UTC kayması bir gün şaşırtır).

   ÖNEMLİ (hukuk): addMonths TAKVİM ayı kullanır (CMK m.39/3) — son ayda
   sayıca karşılık gelen güne, o gün yoksa ayın son gününe. Zamanaşımının
   TCK-72 "30 günlük ay" modeliyle (periodMath) KARIŞTIRILMAMALIDIR.
   ===================================================================== */

import { milliTatilSebebi } from './milliTatiller';

export function parseIso(iso) {
  if (!iso || typeof iso !== 'string') return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso.trim());
  if (!m) return null;
  const y = Number(m[1]), mo = Number(m[2]), d = Number(m[3]);
  const date = new Date(y, mo - 1, d);
  if (date.getFullYear() !== y || date.getMonth() !== mo - 1 || date.getDate() !== d) return null;
  return date;
}

export function toIso(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function addDays(iso, n) {
  const date = parseIso(iso);
  if (!date) return null;
  date.setDate(date.getDate() + n);
  return toIso(date);
}

/**
 * iso + n ay (CMK m.39/3 / HMK m.92): son ayda sayıca karşılık gelen güne;
 * o gün yoksa (ör. 31 Ocak + 1 ay) hedef ayın son gününe.
 */
export function addMonths(iso, n) {
  const date = parseIso(iso);
  if (!date) return null;
  const gun = date.getDate();
  const t = new Date(date.getFullYear(), date.getMonth() + n, 1);
  const ayinSonGunu = new Date(t.getFullYear(), t.getMonth() + 1, 0).getDate();
  t.setDate(Math.min(gun, ayinSonGunu));
  return toIso(t);
}

export function haftaSonuMu(date) {
  const g = date.getDay();
  return g === 0 || g === 6;
}

/** İki ISO tarih arası takvim günü farkı (b - a). Geçersizse null. Pozitif = b, a'dan sonra. */
export function gunFarki(a, b) {
  const da = parseIso(a);
  const db = parseIso(b);
  if (!da || !db) return null;
  return Math.round((db.getTime() - da.getTime()) / 86400000);
}

/** Süre birimine göre uzatma öncesi son günü bulur (CMK m.39 / HMK m.92). */
export function sonGunHesapla(tebligIso, sure, birim) {
  if (birim === 'hafta') return addDays(tebligIso, sure * 7); // son haftada aynı isimli gün
  if (birim === 'ay') return addMonths(tebligIso, sure);      // son ayda sayıca karşılık gelen gün
  return addDays(tebligIso, sure);                            // gün
}

/**
 * Tatil ise sebebini döndürür, değilse null.
 * diniSet: etkin dinî bayram günleri kümesi (diniSetKur ile kurulur).
 */
export function tatilSebebi(iso, diniSet) {
  const date = parseIso(iso);
  if (!date) return null;
  const g = date.getDay();
  if (g === 6) return 'Hafta sonu (Cumartesi)';
  if (g === 0) return 'Hafta sonu (Pazar)';
  const milli = milliTatilSebebi(iso);
  if (milli) return milli;
  if (diniSet && diniSet.has(toIso(date))) return 'Dinî bayram';
  return null;
}

export function isGunuMu(iso, diniSet) {
  return parseIso(iso) ? tatilSebebi(iso, diniSet) === null : false;
}

/** Gün iş günü değilse ilk iş gününe uzatır; atlanan günleri sebepleriyle döndürür. */
export function ilkIsGunu(iso, diniSet) {
  if (!parseIso(iso)) return { tarih: iso, atlananlar: [] };
  let cur = iso;
  const atlananlar = [];
  let guard = 0;
  while (!isGunuMu(cur, diniSet) && guard < 60) {
    atlananlar.push({ tarih: cur, sebep: tatilSebebi(cur, diniSet) });
    cur = addDays(cur, 1);
    guard += 1;
  }
  return { tarih: cur, atlananlar };
}
